import { useState } from "react";
import { Form } from "react-bootstrap";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NumberRange = ({ objectKey, ky, value, setValue, numberFilter }) => {
  const [amount, setAmount] = useState({
    from: null,
    to: null,
  });

  const handleClear = () => {
    setValue(objectKey, { ...value?.[objectKey], [ky]: "" });
  };

  return (
    <Form.Group className="d-flex">
      <div className="d-flex" style={{ position: "relative", width: "135px" }}>
        <Form.Control
          type="number"
          min={numberFilter?.min}
          max={numberFilter?.max}
          placeholder={ky=='from'?'Min':'Max'}
          size="sm"
          value={value?.[objectKey]?.[ky]}
          onChange={(e) => {
            console.log('NumberRange onChange - Raw value:', e.target.value);
            console.log('NumberRange onChange - Current state:', value?.[objectKey]);
            
            // Only update if we have a valid number or empty string
            if (e.target.value === '' || !isNaN(e.target.value)) {
              const newValue = e.target.value === "" ? "" : parseInt(e.target.value, 10);
              console.log('NumberRange onChange - Parsed value:', newValue);
              setValue(objectKey, {
                ...value?.[objectKey],
                [ky]: newValue,
              });
            }
          }}
        />
        {value?.[objectKey]?.[ky] && (
          <FontAwesomeIcon
            icon={faTimes}
            onClick={handleClear}
            className="cursor point"
            style={{
              position: "absolute",
              top: "50%",
              right: "34px",
              transform: "translateY(-60%)",
              color: "#281E5D",
            }}
          />
        )}
      </div>
    </Form.Group>
  );
};

export default NumberRange;
